import React from 'react';
import { TargetRangeProps } from 'apps/sigma2-ui/src/components/key-factors/BreakdownSectionUtils';
import cn from 'classnames';

export const TargetRangeGraph = (props: TargetRangeProps) => {
  return (
    <div className="w-full">
      <div className="relative w-full h-5">
        <div className="w-full h-1/2 border-b-2 border-solid border-gray-200"></div>
        <div
          className={cn(
            'absolute top-0 h-5 border-x-2 border-solid border-royal-600 bg-[#DFE6F9]/75 ',
          )}
          style={{
            left: props.rangeCssLeftPercentage + '%',
            width: props.rangeCssWidthPercentage + '%',
          }}
        ></div>
      </div>
      <div className="flex w-full justify-between text-royal-600 text-xs leading-5 tracking-tight font-bold pt-2">
        <span>{props.leftEndpointLabel}</span>
        <span>{props.rightEndpointLabel}</span>
      </div>
    </div>
  );
};
